import React from 'react';
import { makeStyles } from '@material-ui/core';
import { colorSet, clsx } from '@components/Provider';
import { Checkbox, CheckboxProps } from '@material-ui/core';

export const useErrorDialogStyles = makeStyles((theme) => ({
  paper: {
    margin: ' 12px',
    textAlign: 'center',
    width: 608,
    borderRadius: 8,
    boxShadow:
      '0px 26px 36px -4px rgba(0, 0, 0, 0.2), 0px 36px 72px 5px rgba(0, 0, 0, 0.14), 0px 16px 64px 8px rgba(0, 0, 0, 0.12)',
    '& > img': {
      margin: '64px auto 32px auto',
      width: '315px',
      height: '120px',
      [theme.breakpoints.down('md')]: {
        margin: '48px auto 24px auto'
      }
    }
  },
  contentRoot: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 32px 32px'
  },
  titleRoot: {
    marginBottom: 16,
    alignItems: 'center',
    justifyContent: 'center'
  },
  timeZoneRoot: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 0px',
    backgroundColor: colorSet.gray200,
    '& .time': {
      marginLeft: 4,
      ...theme.typography.h4,
      fontWeight: 700,
      color: colorSet.primary500,
      [theme.breakpoints.down('md')]: {
        ...theme.typography.body1,
        fontWeight: 700
      }
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  title: {
    paddingBottom: '4px',
    '& .MuiTypography-root': {
      wordBreak: 'keep-all',
      fontWeight: 700,
      fontSize: 32
    }
  },
  description: {
    wordBreak: 'break-all'
  },
  descriptionSub: {
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F3F5F7',
    fontWeight: 500,
    color: '#323D45',
    fontSize: 14,
    marginTop: 24,
    '& .time': {
      fontWeight: 700,
      marginLeft: 4
    }
  },
  unstableDescriptionSub: {
    ...theme.typography.body2,
    padding: '0px 40px',
    textAlign: 'left',
    fontWeight: 400,
    wordBreak: 'break-all',
    '& .bold': {
      fontWeight: 700
    },
    '& .blueBold': {
      color: colorSet.primary500,
      fontWeight: 700
    }
  },
  unstableCloseButton: {
    boxShadow: 'unset',
    backgroundColor: colorSet.backgroundLight
  },
  actions: {
    padding: '8px'
  },
  cancelButton: {
    color: theme.palette.text.secondary
  },
  stagingAction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  stagingContent: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: 20,
    fontWeight: 400,
    color: colorSet.gray900,
    '& .bold': {
      fontWeight: 700
    }
  },
  span: {
    '&.primary': {
      color: colorSet.primary500
    },
    '&.textPrimary': {
      color: colorSet.gray900
    },
    '&.bold': {
      fontWeight: 700 + `!important`
    },
    '&.body2': {
      ...theme.typography.body2
    },
    '&.body1': {
      ...theme.typography.body1
    },
    '&.m-32': {
      marginBottom: 32
    }
  }
}));
export const useUnstableNoticeStyles = makeStyles((theme) => {
  return {
    paper: {
      margin: ' 12px',
      textAlign: 'center',
      width: 544,
      height: 458,
      '& > img': {
        marginTop: 40,
        width: '320px',
        height: '120px'
      }
    },
    banner: {
      margin: '12px auto',
      borderBottom: `solid 1px ${colorSet.backgroundLight}`,
      width: '95px',
      paddingBottom: '4px'
    },
    title: {
      paddingBottom: '4px',
      '& .MuiTypography-root': {
        wordBreak: 'keep-all',
        fontWeight: 700,
        fontSize: 32
      }
    },
    description: {
      fontSize: '14px',
      lineHeight: 1.43,
      fontWeight: 'normal',
      whiteSpace: 'pre-wrap',
      color: '#323D45'
    },
    unstableDescriptionSub: {
      height: 80,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F3F5F7',
      fontWeight: 500,
      color: '#323D45',
      fontSize: 14,
      marginTop: 24,
      '& .time': {
        fontWeight: 700,
        marginLeft: 4
      },
      '& .MuiTypography-root': {
        padding: '0px 40px',
        textAlign: 'left'
      }
    },
    actions: {
      padding: '8px'
    },
    cancelButton: {
      color: theme.palette.text.secondary
    }
  };
});

export const useRefferalStyles = makeStyles((theme) => ({
  paper: {
    minWidth: 486,
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 16px)',
      minWidth: 373
    },
    margin: 0,
    '& .MuiDialogContent-root': {
      overflow: 'visible'
    }
  },

  title: {
    padding: '16px 16px 9.5px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& img': {
      height: 12
    },
    '& .MuiIconButton-root': {
      padding: 0
    }
  },
  subTitle: {
    fontWeight: 'bold',
    alignSelf: 'center',
    fontSize: 32,
    marginTop: 20,
    lineHeight: '48px',
    marginBottom: 17.5,
    zIndex: 2,
    color: colorSet.gray900
  },
  description1: {
    fontSize: 14,
    lineHeight: '143%',
    whiteSpace: 'pre-wrap',
    marginBottom: 4
  },
  description2: {
    fontSize: 14,
    lineHeight: '143%',
    whiteSpace: 'pre-wrap',
    marginLeft: '-4px',
    marginBottom: 18,
    '& b': {
      backgroundColor: colorSet.gray000,
      padding: '0px 4px'
    }
  },
  btnGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& button': {
      '&:last-child': {
        marginTop: 10,
        color: colorSet.primary700
      }
    }
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
    '& .MuiIconButton-root': {
      padding: 0,
      marginRight: 10
    }
  },
  MDImgBox: {
    display: 'flex',
    position: 'relative',
    height: 50,
    flexDirection: 'row'
  },
  MDImg: {
    position: 'absolute',
    bottom: 0,
    right: 20,
    height: 100,
    justifySelf: 'flex-start',
    [theme.breakpoints.down('md')]: {
      opacity: 0.3
      // filter: 'drop-shadow(0px 6px 8px rgba(0, 0, 0, 0.25))'
    }
  }
}));

export const useUpdatedNoticeStyles = makeStyles((theme) => {
  return {
    wrapper: {
      'z-index': '9999 !important',
      '& .MuiPaper-elevation24': {
        boxShadow: 'none'
      },
      '& .MuiDialog-paperWidthLg': {
        maxWidth: 448,
        overflow: 'visible',
        maxHeight: 568,
        height: '100%',
        backgroundColor: 'transparent',
        position: 'relative',
        boxSizing: 'content-box',
        padding: '0px 80px',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
          margin: 16,
          maxWidth: 375,
          width: 'calc(100% - 16px)',
          maxHeight: 520,
          padding: 0,
          alignItems: 'center'
        }
      },
      '& .navigateNext': {
        minWidth: 44,
        minHeight: 44,
        borderRadius: '50%',
        backgroundColor: colorSet.gray000,
        right: 0,
        top: 'calc(100% / 2 - 40px)',
        position: 'absolute',
        boxShadow:
          '0px 16px 64px 8px #0000001F, 0px 36px 72px 5px #00000024, 0px 26px 36px -4px #00000033',
        [theme.breakpoints.down('md')]: {
          display: 'none'
        },
        '&:hover': {
          color: colorSet.primary500
        }
      },
      '& .navigatePrev': {
        minWidth: 44,
        minHeight: 44,
        borderRadius: '50%',
        backgroundColor: colorSet.gray000,
        left: 0,
        top: 'calc(100% / 2 - 40px)',
        position: 'absolute',
        boxShadow:
          '0px 16px 64px 8px #0000001F, 0px 36px 72px 5px #00000024, 0px 26px 36px -4px #00000033',
        [theme.breakpoints.down('md')]: {
          display: 'none'
        },
        '&:hover': {
          color: colorSet.primary500
        }
      }
    },
    swipezone: {
      position: 'relative',
      borderRadius: 4,
      maxWidth: 600,
      height: '100%',
      width: '100%',
      '& .swiper-pagination': {
        height: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        '& .swiper-pagination-bullet': {
          background: colorSet.gray400
        },
        '& .swiper-pagination-bullet-active': {
          background: colorSet.gray900
        }
      }
    },
    slide: {
      width: '100% !important',
      backgroundColor: colorSet.gray000,
      '& .MuiCardMedia-root': {
        width: '100%',
        backgroundSize: 'contain'
      },
      '& .MuiDialogTitle-root': {
        padding: 0
      }
    },
    content: {
      width: '100%',
      height: '100%',
      position: 'relative',
      borderRadius: 8,
      padding: 0,
      backgroundColor: colorSet.gray000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      boxShadow:
        '0px 16px 64px 8px #0000001F, 0px 36px 72px 5px #00000024, 0px 26px 36px -4px #00000033',
      '& .title': {
        paddingTop: 24
      },
      '& .swipe_button': {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        padding: '0px 16px',
        'z-index': 2
      },
      '& .content_buttons': {
        borderTop: `1px solid ${colorSet.gray400}`,
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px 16px',
        [theme.breakpoints.down('md')]: {
          padding: 16
        },
        '& button': {
          '&:not(:last-child)': {
            marginBottom: 8
          },
          '& > span': {
            whiteSpace: 'nowrap'
          }
        }
      }
    },
    contentText: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '36px 44px',
      width: '100%',
      height: 246,
      maxHeight: 246,
      '& .contentText_title': {
        marginTop: 16
      },
      '& .contentText_detail': {
        marginTop: 12,
        whiteSpace: 'pre-line',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
          whiteSpace: 'unset'
          // wordBreak: 'break-word'
        }
      },
      [theme.breakpoints.down('md')]: {
        height: 'unset',
        padding: '12px 16px 36px'
      },
      backgroundColor: colorSet.gray000
    },
    slideBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      padding: `16px 24px`,
      backgroundColor: colorSet.gray000,
      height: '100%',
      whiteSpace: 'break-spaces',
      [theme.breakpoints.down('md')]: {
        height: '100%',
        padding: 16
      },
      '& .slideImg': {
        height: 315,
        display: 'flex',
        alignItems: 'center'
      }
    }
  };
});
const useCheckBoxStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5'
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)'
    }
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""'
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3'
    }
  }
});

// Inspired by blueprintjs
export const StyledCheckbox = (props: CheckboxProps) => {
  const classes = useCheckBoxStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...props}
    />
  );
};

export const useEventNoticeStyles = makeStyles((theme) => ({
  paper: {
    '& .MuiPaper-root': {
      overflow: 'visible',
      minWidth: '600px',
      [theme.breakpoints.down('md')]: {
        position: 'relative',
        width: 'calc(100vw - 64px)',
        minWidth: '311px',
        top: '228px'
      }
    },
    '& .MuiDialog-paperScrollPaper': {
      [theme.breakpoints.down('md')]: {
        maxHeight: '2000px'
      }
    },
    '&.MuiDialog-root': {
      overflowY: 'scroll',
      overflowX: 'hidden'
    }
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  cancelBtn: {
    position: 'absolute',
    alignSelf: 'flex-end',
    top: '-35px',
    color: colorSet.gray000,
    marginLeft: 'auto',
    fontSize: 15,
    fontWeight: 500,
    width: 80,
    '& svg': {
      marginRight: 12,
      fontSize: 17
    }
  },
  title: {
    '&.MuiDialogTitle-root': {
      paddingBottom: '0px'
    },
    '& .MuiTypography-h6': {
      display: 'flex',
      justifyContent: 'center',
      padding: '12px',
      alignItems: 'center',
      '& img': {
        width: '306px',
        [theme.breakpoints.down('md')]: {
          width: '270px',
          height: '64px'
        }
      }
    }
  },
  content: {
    '&.MuiDialogContent-root': {
      overflow: 'visible'
    },
    textAlign: 'center',
    lineHeight: '24px',
    wordBreak: 'break-word',
    [theme.breakpoints.down('md')]: {
      height: '72px',
      padding: '0px 24px'
    }
  },
  nextLine: {
    display: 'inline',
    [theme.breakpoints.down('md')]: {
      display: 'block'
    }
  },
  contentText: {
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '20px'
  },
  cardArea: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: '8px 20px',
    '& .MuiGrid-root': {
      background: colorSet.gray000,
      width: '274px'
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      display: 'flex',
      alignItems: 'center'
    },
    '&.MuiDialogContent-root': {
      overflow: 'visible'
    }
  },
  contentCard: {
    textAlign: 'center',
    boxSizing: 'border-box',
    padding: '20px',
    margin: '8px 0px',
    '& .numbering': {
      width: '25px',
      margin: '0px'
    },
    '& .title': {
      fontSize: '16px',
      letterSpacing: '-0.5px',
      marginBottom: '20px'
    },
    '& .cardIcon': {
      marginBottom: '12px',
      width: '80px'
    },
    '& .body': {
      fontSize: '14px'
    },
    '& .MuiTypography-body1': {
      lineHeight: '20px'
    }
  },
  routeButton: {
    fontSize: '16px',
    fontWeight: 'bold',
    paddingBottom: '16px',
    width: '200px',
    height: '42px',
    padding: '0px',
    margin: '12px 0px',
    alignSelf: 'center',
    '&.MuiDialogActions-root': {
      justifyContent: 'center'
    }
  },
  notSeeingAgainBox: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    width: '600px',
    top: 'calc(100% + 8px)',
    alignSelf: 'flex-start',
    '& .checkBoxText': {
      'line-height': '36px',
      'color': colorSet.gray000
    },
    [theme.breakpoints.down('md')]: {
      height: '160px',
      '& .MuiCheckbox-root': {
        height: '32px'
      }
    }
  }
}));
